import { Spin } from 'antd';
import { NightingaleChart } from '@components/charts';
import { useWidgetData } from '@hooks/useWidgetData';
import type { WidgetDefinition, WidgetRenderProps } from '@/types';

type Data = Array<{ name: string; value: number }>;

function NightingaleWidget({ instance }: WidgetRenderProps) {
  const { data, isLoading } = useWidgetData<Data>(
    instance.id, 'nightingale', instance.config as Record<string, unknown>, instance.refreshInterval,
  );
  if (isLoading) return <Spin />;
  return <NightingaleChart data={data ?? []} />;
}

export const nightingaleWidgetDef: WidgetDefinition = {
  type: 'nightingale',
  name: 'Nightingale Rose',
  description: 'Angular area pie variant',
  icon: 'CameraOutlined',
  category: 'chart',
  defaultTitle: 'Nightingale Rose',
  defaultConfig: {},
  minW: 3, minH: 4, defaultW: 4, defaultH: 6,
  component: NightingaleWidget,
  settingsSchema: { fields: [] },
};
